import store from '../store';

export default async function entryMarketReport({ next, router }) {

    store.commit('SET_PRODUCT_TYPE', 'EntryMarketReport');
   
    if (store.getters.isAuthenticated)
        return router.push({ name: "CreateReportFormat", params: { report: 'market' } });
    else
        return router.push({ name: "Login" });


    return next();
}
